import React, { useCallback, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import './App.css';
import IntroSplash from './components/IntroSplash';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Quality from './components/Quality';
import Certifications from './components/Certifications';
import Sustainability from './components/Sustainability';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollProgress, { CursorBlob } from './components/ScrollProgress';
import { Toaster } from './components/ui/toaster';

function App() {
  const [intro, setIntro] = useState(true);
  const finishIntro = useCallback(() => setIntro(false), []);

  return (
    <>
      <AnimatePresence>{intro && <IntroSplash key="intro" onDone={finishIntro} />}</AnimatePresence>
      {!intro && <Site />}
    </>
  );
}

function Site() {
  return (
    <div className="App min-h-screen bg-[#fafaf7] overflow-x-hidden relative">
      <ScrollProgress />
      <CursorBlob />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Products />
        <Quality />
        <Certifications />
        <Sustainability />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
